import ComponentStyle from '../ComponentStyle'

export default function ComponentBlocksButton ({ Text, Link, Variant, Size }) {
  return (
    <div className="col">
      <ComponentStyle config={{
        Size
      }}
      >
        <a
          href={Link}
          className={`btn btn-${Variant}`}
          target="_blank"
          rel="noreferrer"
        >
          {Text}
        </a>
      </ComponentStyle>
    </div>
  )
}
